import { useTraitSwapResolver } from '../hooks/useTraitSwap';
import config from '../config';
import TraitSwapPreviewImages from './TraitSwapPreviewImages';
import TraitSwapPreviewLayer from './TraitSwapPreviewLayer';

const TraitSwapPreview = () => {
  useTraitSwapResolver();

  return (
    <div className='flex flex-col gap-12'>
      <div className='grid grid-cols-1 xl:grid-cols-12 gap-y-8 xl:gap-8'>
        <div className='xl:col-span-6 col-span-1'>
          <div className='flex flex-col gap-4 sticky top-5'>
            <TraitSwapPreviewImages />
          </div>
        </div>

        <div className='xl:col-span-6 col-span-1 flex w-full flex-col gap-4'>
          <div>
            <div className='flex justify-between mb-3'>
              <p className='text-gray-100 text-lg font-medium'>First Kitty</p>
              <p className='text-gray-100 text-lg font-medium'>Second Kitty</p>
            </div>
            <div className='flex gap-4 flex-col'>
              {config.fourthLitterTraitLayers.map((layer) => (
                <TraitSwapPreviewLayer key={layer} layer={layer} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TraitSwapPreview;
